import {wsIsElement} from '@scripts/app/helpers';

export class wsHeader {
  constructor(args) {
    const self = this;

    self.config = Object.assign(
      {
        el: null,
      },
      args,
    );

    if (!wsIsElement(args.el)) {
      return console.warn('Set el attribute with header element.');
    }

    this.initDesktopSubmenus();

    self.updateScroll();
    window.addEventListener('scroll', self.updateScroll);

    let mm = window.matchMedia(`(min-width: 1024px)`);
    mm.addEventListener('change', () => {
      const mobileMenu = document.getElementById('mobile-menu');
      if (mm.matches && mobileMenu && mobileMenu.matches(':popover-open')) {
        mobileMenu.hidePopover();
      }
    });

    return self;
  }

  updateScroll() {
    if (window.scrollY >= 24) {
      document.documentElement.dataset.scrolled = 'true';
    } else {
      delete document.documentElement.dataset.scrolled;
    }
  }

  initDesktopSubmenus() {
    const self = this;

    const nav = self.config.el.querySelector('.c-hd-desktop__nav');

    if (nav) {
      const submenus = nav.querySelectorAll('.menu-item > .submenu');

      submenus.forEach((submenu) => {
        const links = submenu.querySelectorAll('.js-last-hovered > .submenu-item-link');

        links.forEach((link) => {
          link.addEventListener('mouseenter', () => {
            links.forEach((l) => {
              l.parentElement.classList.toggle('is-hovered', l === link);
            });
          });
          link.addEventListener('focus', () => {
            links.forEach((l) => {
              l.parentElement.classList.toggle('is-hovered', l === link);
            });
          });
        });

        links[0]?.parentElement?.classList.add('is-hovered');
      });
    }
  }
}
